// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1I0vT","row":"styles_row__1Y50n","summary":"styles_summary__1x5mI","contentAssociations":"styles_contentAssociations__3EhY3"};